import { useMemo } from "react";
import { createPortal } from "react-dom";
import { BlockLink } from "@/components/DrilldownLink";
import { buildPriorityDomainRows } from "@/utils/executivePriorityDomainsDerived";
import "./UsmRiskSchoolsModal.css";
import "./ExecutivePriorityDomainsModal.css";

const ExecutivePriorityDomainsModal = ({
  open,
  onClose,
  domains = {},
  blockRankings = [],
  scopeLabel = "District scope",
  shiValue = 0,
  ragStatus = "Amber",
  onDomainNavigate,
}) => {
  const rows = useMemo(
    () => buildPriorityDomainRows(domains, blockRankings),
    [domains, blockRankings]
  );

  if (!open) return null;

  return createPortal(
    <div className="usm-risk-modal-overlay epd-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="usm-risk-modal usm-risk-modal-wide epd-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="epd-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="usm-risk-modal-head">
          <div>
            <p className="usm-risk-modal-eyebrow">Executive overview · {scopeLabel}</p>
            <h3 id="epd-modal-title">4 Priority Domains — Problems, Blocks & Resolutions</h3>
            <p className="usm-risk-modal-sub">
              OSH composite {shiValue}% ({ragStatus}). Each domain uses a 25% weight in the school health index.
              At-risk blocks are those scoring below district average or under the 70-point threshold.
            </p>
          </div>
          <button type="button" className="usm-risk-modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>

        <div className="usm-risk-modal-body epd-modal-body">
          <table className="usm-risk-modal-table usm-risk-modal-table-wide epd-table">
            <thead>
              <tr>
                <th>Domain</th>
                <th>Index</th>
                <th>Status</th>
                <th>Problem</th>
                <th>At-risk blocks</th>
                <th>How to resolve</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id}>
                  <td>
                    <button
                      type="button"
                      className="epd-domain-link"
                      onClick={() => {
                        onDomainNavigate?.(row.tabId);
                        onClose();
                      }}
                    >
                      {row.label}
                    </button>
                  </td>
                  <td className="epd-index">{row.index}</td>
                  <td>
                    <span className={`epd-tag epd-tag-${row.statusClass}`}>{row.status}</span>
                  </td>
                  <td className="epd-problem">{row.problem}</td>
                  <td className="epd-blocks">
                    {row.atRiskBlocks.length > 0 ? (
                      <ul className="epd-block-list">
                        {row.atRiskBlocks.map((block) => (
                          <li key={block.block_code || block.block_name}>
                            <BlockLink blockCode={block.block_code} blockName={block.block_name}>
                              {block.block_name}
                            </BlockLink>
                            <span className="epd-block-score">{block[row.scoreKey] ?? "—"}</span>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      "—"
                    )}
                  </td>
                  <td className="epd-resolution">{row.resolution}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default ExecutivePriorityDomainsModal;
